import React from 'react';
import CertificationQuestionMgmt from '../../screens/CertificationQuestionMgmt';

const CertificationQuestionAdminMgmt = () => {
    return <CertificationQuestionMgmt />
}

export default CertificationQuestionAdminMgmt;